import { render, staticRenderFns } from "./IndustryNewsList.vue?vue&type=template&id=31a7bc78&scoped=true"
import script from "./IndustryNewsList.vue?vue&type=script&lang=js"
export * from "./IndustryNewsList.vue?vue&type=script&lang=js"
import style0 from "./IndustryNewsList.vue?vue&type=style&index=0&id=31a7bc78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a7bc78",
  null
  
)

export default component.exports